import React, { useState } from 'react';
import { Send, XCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../services/api.js';

export default function ModalCorreo({ item, replyTo, onClose, onSent }) {
  const [asunto, setAsunto]   = useState(replyTo ? `Re: ${replyTo.payload?.asunto || 'Tu mensaje'}` : '');
  const [mensaje, setMensaje] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (!mensaje.trim()) {
      toast.error('El mensaje es obligatorio.');
      return;
    }
    setSending(true);
    try {
      await api.post(`/solicitudes/${item.id}/correo`, {
        asunto: asunto || 'Respuesta a tu solicitud',
        mensaje,
        reply_to_step_id: replyTo?.id
      });
      toast.success('Correo enviado al ciudadano y registrado en el historial.');
      onSent();
      onClose();
    } catch {
      toast.error('Error al enviar el correo.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
            <Send size={18} color="var(--primary)" /> Enviar Correo al Ciudadano
          </h2>
          <button className="modal-close" onClick={onClose}><XCircle size={18} /></button>
        </div>

        <p style={{ fontSize: '0.83rem', color: 'var(--text-muted)', marginBottom: '1rem' }}>
          Para: <strong>{item.nombre_solicitante}</strong> ({item.email})
          &nbsp;·&nbsp;Solicitud <strong>{item.numero_seguimiento}</strong>
        </p>

        {replyTo && (
          <div style={{
            background: '#f8fafc', padding: '0.8rem', borderRadius: 10, marginBottom: '1.2rem',
            borderLeft: '4px solid var(--primary)', border: '1px solid #e2e8f0', borderLeftWidth: 4
          }}>
            <div style={{ fontSize: '0.65rem', color: 'var(--primary)', fontWeight: 800, marginBottom: 4, textTransform: 'uppercase' }}>
              Mensaje del Ciudadano:
            </div>
            <div style={{ fontSize: '0.8rem', color: '#475569', fontStyle: 'italic', lineHeight: 1.4 }}>
              "{replyTo.payload?.mensaje || replyTo.payload?.comentario}"
            </div>
          </div>
        )}

        <div className="form-group">
          <label>Asunto</label>
          <input value={asunto} onChange={e => setAsunto(e.target.value)} placeholder="Ej: Información adicional requerida" />
        </div>
        <div className="form-group">
          <label>Mensaje de Respuesta</label>
          <textarea rows={5} value={mensaje} onChange={e => setMensaje(e.target.value)}
            placeholder="Escribe aquí tu respuesta para el ciudadano..." />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '1rem' }}>
          <button className="btn btn-secondary" onClick={onClose} disabled={sending}>Cancelar</button>
          <button className="btn btn-primary" onClick={handleSend} disabled={sending}>
            {sending ? <span className="spinner" style={{ width: 16, height: 16 }} /> : <><Send size={14} /> Enviar Respuesta</>}
          </button>
        </div>
      </div>
    </div>
  );
}
